export const DOM = {
  PLAY: 'event/dom/play',
  PLAYING: 'event/dom/playing',
  PAUSE: 'event/dom/pause',
  ENDED: 'event/dom/ended',
  TIMEUPDATE: 'event/dom/timeupdate',
  ERROR: 'event/dom/error',
  WAITING: 'event/dom/waiting',
}

export const PLAYER = {
  QUALITY_CHANGE: 'event/player/quality-change',
  REQUEST_PLAY: 'event/player/request-play',
  PLAY_REJECTED: 'event/player/play-rejected',
  REQUEST_PAUSE: 'event/player/request-pause',
  PLAY_COUNT: 'event/player/play-count',
  PLAY_FAILED: 'event/player/play-failed',
  ENTER_FULLSCREEN: 'event/player/enter-fullscreen',
  EXIT_FULLSCREEN: 'event/player/exit-fullscreen',
}
